import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { lazy, Suspense } from 'react';
const MapRender = lazy(async () => await import('@components/MapRender'));
import type { MapRenderProps } from '@components/MapRender';
import LoadingPage from '@components/LoadingPage';

const DelayedMapRender: FC<MapRenderProps> = observer(props => {
  const [isReady, setIsReady] = useState(false);
  const width = props.width || '100%';
  const height = props.height || '100%';

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (isReady)
    return (
      <Suspense fallback={<LoadingPage fullHeight />}>
        <MapRender {...props} />
      </Suspense>
    );

  return (
    <div
      style={{
        width,
        height,
        minWidth: width,
        minHeight: height === '100%' ? '100%' : height,
        flex: height === '100%' ? 1 : undefined,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f5f5f5'
      }}
    >
      <LoadingPage fullHeight />
    </div>
  );
});

export default DelayedMapRender;
